import Referrals from "@components/shared/modals/Profile/Referrals";
import Disconnect from "@components/shared/modals/Profile/Disconnect";
import WalletSelect from "@components/shared/modals/Profile/Select";
import MobileMenu from "@components/shared/modals/Profile/MobileMenu";
import { Create, Import } from "@components";
import ConnectProfile from "@components/shared/modals/Wallet/ConnectProfile";
import Transfer from "../modals/Wallet/Transfer";
import { useModalStore, createModalHelpers } from "@stores/unified-modal.store";
import React from "react";

import { useWallet } from "@stores/wallet.store";
import { useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";

const GlobalModals: React.FC = () => {
    // Global /sniper mnemonic modal logic
    const isMnemonic = useWallet((s) => s.isMnemonic());
    const isWalletLoading = useWallet((s) => s.isLoading);
    const location = useLocation();
    const prevIsMnemonicRef = useRef<boolean | undefined>(undefined);
    const { openModal, closeModal } = createModalHelpers();
    // Only prompt for wallet selection once per session
    const [hasPromptedWallet, setHasPromptedWallet] = React.useState(false);
    useEffect(() => {
        if (isWalletLoading) return;
        if (location.pathname === "/sniper") {
            if (!isMnemonic && !hasPromptedWallet) {
                openModal("select");
                setHasPromptedWallet(true);
            }
        }
        // Do not forcibly close the select modal on other pages; allow other pages to control it independently.
        prevIsMnemonicRef.current = isMnemonic;
    }, [isMnemonic, openModal, closeModal, location.pathname, isWalletLoading, hasPromptedWallet]);
    const { modalStates: modals, toggleModal } = useModalStore();
    return (
        <>
            <Referrals isVisible={modals.referal} setIsVisible={() => toggleModal("referal")} />
            <Disconnect isVisible={modals.disconnect} setIsVisible={() => toggleModal("disconnect")} />
            <WalletSelect isVisible={modals.select} setIsVisible={() => toggleModal("select")} />
            <Import isVisible={modals.import} setIsVisible={() => toggleModal("import")} />
            <Transfer />
            <ConnectProfile
                setIsCreateModalVisible={() => openModal("create")}
                setIsImportModalVisible={() => openModal("import")}
                isVisible={modals.connect}
                setIsVisible={() => toggleModal("connect")}
            />
            <Create isVisible={modals.create} setIsVisible={() => toggleModal("create")} />
            <MobileMenu
                isVisible={modals.mobile}
                setIsVisible={() => toggleModal("mobile")}
                showDepositModal={() => toggleModal("transfer")}
                showRefferalModal={() => toggleModal("referal")}
                showDisconnectModal={() => toggleModal("disconnect")}
                showConnectModal={() => toggleModal("connect")}
            />
        </>
    );
};

export default GlobalModals;
